import http from '../http'
const BASE_URL = 'arl'

class ArlAPI {
  async getAllARLs() {
    const response = await http(`${BASE_URL}`, 'GET')
    return response
  }

}

export default new ArlAPI()